import React from "react";
import { useTranslation } from "react-i18next";
import { CButton } from "@app/components/Common";
import { View } from "@/styles/reactnative";
import { useTradeModalStore } from "../../../../../../../hooks/trade/modalStore";

const AccountDeposit = ({ bgColor, color }) => {
  const { t } = useTranslation();

  const { data: modalStore, mutate: muatateModalStore } = useTradeModalStore();
  const openModal = () => {
    muatateModalStore({ ...modalStore, depositModal: true });
  };
  return (
    <View style={{ flex: 1 }}>
      <CButton
        title={t("deposit")}
        onClick={() => {
          openModal();
        }}
        style={{
          background: bgColor,
          color: color,
          height: 30,
          paddingBlock: 7,
          width: "95%",
          marginRight: 7,
          borderRadius: 2,
        }}
      />
    </View>
  );
};

export default AccountDeposit;
